import { createAsyncThunk } from '@reduxjs/toolkit';
import {
	fetchProjectDataCategories,
	createProjectDataCategory,
	updateProjectDataCategory,
	fetchProjectDataPointDefinitions,
	createProjectDataPointDefinition,
	updateProjectDataPointDefinition,
	fetchProjectDataValues,
	createProjectDataValue,
	updateProjectDataValue,
} from '../../services/project-data-service';
import {
	setCategories,
	addCategory,
	updateCategory,
	setPointDefinitions,
	addPointDefinition,
	updatePointDefinition,
	setValues,
	addValue,
	updateValue,
	setLoading,
	setError,
} from '../stores/projectDataStore';
import {
	ProjectDataCategoryFilter,
	CreateProjectDataCategoryInput,
	UpdateProjectDataCategoryInput,
	ProjectDataPointDefinitionFilter,
	CreateProjectDataPointDefinitionInput,
	UpdateProjectDataPointDefinitionInput,
	ProjectDataValueFilter,
	CreateProjectDataValueInput,
	UpdateProjectDataValueInput,
} from '../models/projectData';
import { showAlert } from '../stores/alertStore';

// Categories
export const fetchCategoriesThunk =
	(filter: ProjectDataCategoryFilter) => async (dispatch: any) => {
		try {
			dispatch(setLoading(true));
			const res = await fetchProjectDataCategories(filter);
			dispatch(setCategories(res.list));
			dispatch(setLoading(false));
		} catch (err: any) {
			dispatch(setError(err.message || 'Failed to fetch categories'));
			dispatch(setLoading(false));
		}
	};

export const createCategoryThunk =
	(data: CreateProjectDataCategoryInput) => async (dispatch: any) => {
		try {
			dispatch(setLoading(true));
			const res = await createProjectDataCategory(data);
			dispatch(addCategory(res));
			dispatch(setLoading(false));
		} catch (err: any) {
			dispatch(setError(err.message || 'Failed to create category'));
			dispatch(setLoading(false));
		}
	};

export const updateCategoryThunk =
	(data: Partial<UpdateProjectDataCategoryInput>) =>
	async (dispatch: any) => {
		try {
			dispatch(setLoading(true));
			const res = await updateProjectDataCategory(data);
			dispatch(updateCategory(res));
			dispatch(setLoading(false));
		} catch (err: any) {
			dispatch(setError(err.message || 'Failed to update category'));
			dispatch(setLoading(false));
		}
	};

// Point Definitions
export const fetchPointDefinitionsThunk =
	(filter: ProjectDataPointDefinitionFilter) => async (dispatch: any) => {
		try {
			dispatch(setLoading(true));
			const res = await fetchProjectDataPointDefinitions(filter);
			dispatch(setPointDefinitions(res.list));
			dispatch(setLoading(false));
		} catch (err: any) {
			dispatch(
				setError(err.message || 'Failed to fetch point definitions')
			);
			dispatch(setLoading(false));
		}
	};

export const createPointDefinitionThunk =
	(data: CreateProjectDataPointDefinitionInput) => async (dispatch: any) => {
		try {
			dispatch(setLoading(true));
			const res = await createProjectDataPointDefinition(data);
			dispatch(addPointDefinition(res));
			dispatch(setLoading(false));
		} catch (err: any) {
			dispatch(
				setError(err.message || 'Failed to create point definition')
			);
			dispatch(setLoading(false));
		}
	};

export const updatePointDefinitionThunk =
	(data: UpdateProjectDataPointDefinitionInput) => async (dispatch: any) => {
		try {
			dispatch(setLoading(true));
			const res = await updateProjectDataPointDefinition(data);
			dispatch(updatePointDefinition(res));
			dispatch(setLoading(false));
		} catch (err: any) {
			dispatch(
				setError(err.message || 'Failed to update point definition')
			);
			dispatch(setLoading(false));
		}
	};

// Values
export const fetchValuesThunk =
	(filter: ProjectDataValueFilter) => async (dispatch: any) => {
		try {
			dispatch(setLoading(true));
			const res = await fetchProjectDataValues(filter);
			dispatch(setValues(res.list));
			dispatch(setLoading(false));
		} catch (err: any) {
			dispatch(setError(err.message || 'Failed to fetch values'));
			dispatch(setLoading(false));
		}
	};

export const createValueThunk =
	(data: CreateProjectDataValueInput) => async (dispatch: any) => {
		try {
			dispatch(setLoading(true));
			const res = await createProjectDataValue(data);
			dispatch(addValue(res));
			dispatch(setLoading(false));
		} catch (err: any) {
			dispatch(setError(err.message || 'Failed to create value'));
			dispatch(setLoading(false));
		}
	};

export const updateValueThunk =
	(data: UpdateProjectDataValueInput) => async (dispatch: any) => {
		try {
			dispatch(setLoading(true));
			const res = await updateProjectDataValue(data);
			dispatch(updateValue(res));
			dispatch(setLoading(false));
			dispatch(
				showAlert({
					message: 'Successfully updated',
					severity: 'success',
				})
			);
		} catch (err: any) {
			dispatch(setError(err.message || 'Failed to update value'));
			dispatch(setLoading(false));
		}
	};
